import script from "./TotalCashMonthly.vue?vue&type=script&lang=ts&setup=true"
export * from "./TotalCashMonthly.vue?vue&type=script&lang=ts&setup=true"

import "./TotalCashMonthly.vue?vue&type=style&index=0&id=496eb332&lang=scss"

const __exports__ = script;

export default __exports__